module.exports = __webpack_public_path__ + "img/contentquo.6be0162e.svg";